import store from '../../store/index';
import captureRenderBlockingException from '../../tracking/helpers/captureRenderBlockingException';

export default async function beforeEnterReg3(to, from, next) {
  try {
    const completed = await store.dispatch('registration/checkReg2Completed');
    if (completed === 'redirect') {
      return;
    }

    if (!completed) {
      next('/v/pessoal');
    } else {
      next();
    }
  } catch (e) {
    store.dispatch('setBackendErrorMessage');
    captureRenderBlockingException(e);
    next('/v/pessoal');
  }
}
